import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PropertyTypeGroupingService } from '@rma/generic/ui/filters/public/util-property-type-grouping-filter';
import { ProfileMapCTAComponent } from '@rma/profiles/public/ui-profile-map-cta';
import { BedroomsOptionType, BedroomsOptionsToFilter } from '../domain/bedroom-options';
import { PropertyTypeMapping, PropertyTypes } from '../domain/property-types';
import { FindMyAgentResponseVM } from '../domain/results';

@Component({
  selector: 'rma-maps',
  imports: [ProfileMapCTAComponent],
  templateUrl: './maps.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapsComponent implements OnChanges {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly propertyTypeGroupingService = inject(PropertyTypeGroupingService);

  @Input()
  agent!: FindMyAgentResponseVM;

  mapUrl = '';
  mapUrlParams!: Params;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['agent'] && this.agent) {
      this.mapUrl = this.agent.profileUrl.replace('overview', 'map');
      this.mapUrlParams = this.getMapUrlParams(this.activatedRoute.snapshot.queryParams);
    }
  }

  /**
   * Far from ideal, why are the types different
   * @param params
   * @returns
   */
  private getMapUrlParams(params: Params): Params {
    const mapParams: Params = {};

    const { propertyType, bedrooms } = params;

    if (propertyType) {
      const propertyTypeGroup = this.propertyTypeGroupingService.getPropertyTypeGroup(PropertyTypeMapping[propertyType as PropertyTypes]);
      mapParams['propertyTypes'] = propertyTypeGroup;
    }

    if (bedrooms) {
      mapParams['bedroomsMin'] = BedroomsOptionsToFilter[bedrooms as BedroomsOptionType];
      mapParams['bedroomsMax'] = BedroomsOptionsToFilter[bedrooms as BedroomsOptionType];
    }

    return mapParams;
  }
}
